/**
 * Rango de dias (desde y hasta) bajo un solo rotulo, para las barras de filtros
 * del backoffice (pedidos, movimientos de inventario). Los dias son de Chile y
 * se aplican al elegirlos: un `<input type="date">` solo avisa el cambio cuando
 * la fecha esta completa.
 */
export interface FiltroFechasProps {
  desde: string | undefined;
  hasta: string | undefined;
  onCambiar(desde: string | undefined, hasta: string | undefined): void;
}

function valorDia(texto: string): string | undefined {
  return texto.length > 0 ? texto : undefined;
}

/** Desde y hasta bajo un solo rotulo, como el rango del total. */
export function FiltroFechas({ desde, hasta, onCambiar: avisar }: FiltroFechasProps) {
  /** Un rango escrito al reves se da vuelta en vez de dejar la tabla vacia. */
  function onCambiar(nuevoDesde: string | undefined, nuevoHasta: string | undefined): void {
    if (nuevoDesde !== undefined && nuevoHasta !== undefined && nuevoDesde > nuevoHasta) {
      avisar(nuevoHasta, nuevoDesde);
    } else {
      avisar(nuevoDesde, nuevoHasta);
    }
  }

  const clase = (valor: string | undefined) =>
    valor !== undefined ? 'entrada entrada-fecha activo' : 'entrada entrada-fecha';

  return (
    <div className="filtro filtro-stock">
      <span className="filtro-et" id="filtro-fecha-et">
        Fecha
      </span>
      <div className="rango-stock" role="group" aria-labelledby="filtro-fecha-et">
        <label>
          <span className="solo-lectores">Desde</span>
          <input
            type="date"
            className={clase(desde)}
            value={desde ?? ''}
            max={hasta}
            onChange={(evento) => {
              onCambiar(valorDia(evento.target.value), hasta);
            }}
          />
        </label>
        <span aria-hidden="true">a</span>
        <label>
          <span className="solo-lectores">Hasta</span>
          <input
            type="date"
            className={clase(hasta)}
            value={hasta ?? ''}
            min={desde}
            onChange={(evento) => {
              onCambiar(desde, valorDia(evento.target.value));
            }}
          />
        </label>
      </div>
    </div>
  );
}
